import { jsx as i, jsxs as S, Fragment as T } from "react/jsx-runtime";
import k, { useState as A, useId as v, useEffect as F, cloneElement as q } from "react";
import { c as y } from "../clsx-OuTLNxxd.js";
import { A as w, E as R } from "../index-PMSPXTub.js";
import '../Accordion.css';const U = "320px", L = "600px", O = "1025px", D = "_header_jc89j_33", G = "_splitHeader_jc89j_37", J = "_iconSlot_jc89j_43", K = "_heading_jc89j_50", Q = "_toggle_jc89j_57", X = "_triggerElement_jc89j_66", Y = "_indicator_jc89j_72", Z = "_trigger_jc89j_66", M = "_contentElement_jc89j_112", V = "_content_jc89j_112", C = "_primary_jc89j_132", N = "_secondary_jc89j_135", ee = "_item_jc89j_141", te = "_dense_jc89j_141", ne = "_nav_jc89j_234", ie = "_link_jc89j_239", oe = "_headingText_jc89j_271", ce = "_linkLabel_jc89j_272", re = "_linkList_jc89j_297", t = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: U,
  "mobile-wide": "480px",
  tablet: L,
  "tablet-wide": "800px",
  desktop: O,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  header: D,
  splitHeader: G,
  iconSlot: J,
  heading: K,
  toggle: Q,
  triggerElement: X,
  indicator: Y,
  trigger: Z,
  contentElement: M,
  content: V,
  primary: C,
  secondary: N,
  item: ee,
  dense: te,
  nav: ne,
  link: ie,
  headingText: oe,
  linkLabel: ce,
  linkList: re
}, le = (d) => {
  if (typeof requestAnimationFrame != "function")
    return d(), () => {
    };
  let x = 0;
  const c = requestAnimationFrame(() => {
    x = requestAnimationFrame(d);
  });
  return () => {
    cancelAnimationFrame(c), cancelAnimationFrame(x);
  };
}, de = ({
  animationDurationMs: d = 0,
  indicatorSize: x = "xsm",
  isOpen: c,
  isPanelLandmark: e = !0,
  onChange: g,
  stroke: z = "bold"
}) => {
  const [n, m] = A(c), s = d > 0, [f, p] = A(c), [u, a] = A(!!c), j = v(), h = v(), b = () => {
    g == null || g(!n), m(!n);
  };
  F(() => {
    c !== n && m(c);
  }, [c]), F(() => {
    if (!s) return;
    if (n)
      return p(!0), le(() => a(!0));
    a(!1);
    const r = setTimeout(() => p(!1), d);
    return () => clearTimeout(r);
  }, [n, s, d]);
  const _ = {
    "aria-controls": h,
    // The watermark travels with the hook, not just with `Accordion.Item`. A caller that drives the
    // disclosure headlessly renders cxy's behaviour on markup of its own — the footer nav does — and
    // without this it is indistinguishable in the DOM from a hand-rolled toggle, which is the one
    // question `data-cxy-name` exists to answer.
    "data-cxy-name": "accordion",
    "aria-expanded": n,
    "data-state": n ? "open" : "closed",
    id: j,
    onClick: b
  }, o = {
    "aria-labelledby": j,
    className: t.contentElement,
    hidden: s ? !f : !n,
    id: h,
    ...e ? { role: "region" } : {},
    ...s ? { "data-animated": "" } : {},
    ...s && u ? { "data-enter": "" } : {}
  };
  return {
    headingProps: _,
    sectionProps: o,
    triggerClass: t.triggerElement,
    Indicator: () => z === "bold" ? /* @__PURE__ */ i(w, { className: t.indicator, size: x }) : /* @__PURE__ */ i(R, { className: t.indicator, size: x })
  };
}, me = 300, xe = ({
  animationDurationMs: d = 0,
  chevronStroke: x = "bold",
  children: c,
  classNames: e,
  heading: g,
  headingAs: z = "h3",
  icon: n,
  indicator: m,
  indicatorSize: s = "xsm",
  isDense: f = !1,
  isOpen: p = !1,
  isPanelLandmark: u = !0,
  links: a,
  onChange: j,
  onLinkClick: h,
  testId: b,
  toggleLabel: _,
  trackingAttribute: o,
  variant: r
}) => {
  const { Indicator: l, headingProps: W, sectionProps: E, triggerClass: B } = de({
    animationDurationMs: d,
    isOpen: p,
    isPanelLandmark: u,
    onChange: j,
    indicatorSize: s,
    stroke: x
  }), I = {
    ...W,
    ...o ? { "data-analytics": o } : {},
    ...b ? { "data-testid": b } : {},
    type: "button"
  }, { id: P, ...$ } = I;
  return /* @__PURE__ */ S(
    "div",
    {
      className: y(
        t.item,
        { [t.dense]: f },
        r && r !== "bare" && t[r],
        e == null ? void 0 : e.wrapper
      ),
      "data-cxy-name": "accordion",
      children: [
        /* @__PURE__ */ i(z, { className: y(t.header, { [t.splitHeader]: _ }, e == null ? void 0 : e.header), children: _ ? /* @__PURE__ */ S(T, { children: [
          /* @__PURE__ */ S("span", { className: y(t.heading, e == null ? void 0 : e.heading), id: P, children: [
            n !== void 0 && /* @__PURE__ */ i("span", { className: t.iconSlot, children: n }),
            g
          ] }),
          /* @__PURE__ */ i(
            "button",
            {
              "aria-label": _,
              className: y(B, t.toggle, e == null ? void 0 : e.button),
              ...$,
              children: m ?? /* @__PURE__ */ i(l, {})
            }
          )
        ] }) : /* @__PURE__ */ S("button", { className: y(B, t.trigger, e == null ? void 0 : e.button), ...I, children: [
          n === void 0 ? g : /* @__PURE__ */ S(T, { children: [
            /* @__PURE__ */ i("span", { className: t.iconSlot, children: n }),
            /* @__PURE__ */ i("span", { className: y(t.headingText, e == null ? void 0 : e.heading), children: g })
          ] }),
          m ?? /* @__PURE__ */ i(l, {})
        ] }) }),
        /* @__PURE__ */ i(
          "div",
          {
            ...E,
            className: y(t.content, e == null ? void 0 : e.content),
            style: { "--cxy-accordion-duration": `${d}ms` },
            children: a ? /* @__PURE__ */ i("ul", { className: t.linkList, children: a.map((H) => /* @__PURE__ */ i("li", { children: /* @__PURE__ */ S("a", { className: t.link, href: H.href, onClick: () => h == null ? void 0 : h(H), children: [
              /* @__PURE__ */ i("span", { className: t.iconSlot, children: H.icon }),
              /* @__PURE__ */ i("span", { className: t.linkLabel, children: H.label })
            ] }) }, `${H.href}-${H.label}`)) }) : c
          }
        )
      ]
    }
  );
}, se = ({
  chevronStroke: d = "bold",
  children: x,
  defaultOpen: c,
  indicatorSize: e = "xsm",
  isDense: g = !1,
  name: z,
  onValueChange: n,
  type: m = "single",
  value: s,
  variant: f = "primary"
}) => {
  const p = m === "multiple", u = s !== void 0, a = k.Children.toArray(x), j = c ? a.map(() => !0) : a.map((o) => !!o.props.isOpen), [h, b] = A(j), _ = (o, r) => {
    let l = [];
    p ? (l = [...h], l[r] = o) : (l = a.map(() => !1), o === !0 && (l[r] = !0)), b(l);
  };
  return /* @__PURE__ */ i(
    "div",
    {
      className: y(t.accordion, f !== "bare" && t[f]),
      "data-cxy-name": "accordion",
      "data-testid": "accordion-component",
      children: x && a.map(
        (o, r) => (
          // Cloned rather than rebuilt from named props: every prop the item declares reaches it,
          // so adding one to `AccordionItemProps` does not also require adding it here.
          q(o, {
            chevronStroke: d,
            indicatorSize: e,
            isDense: g,
            variant: f,
            isOpen: u ? o.props.value === s : h[r],
            key: `${z}-item-${r}`,
            onChange: (l) => {
              var W, E;
              (E = (W = o.props).onChange) == null || E.call(W, l), u ? n == null || n(l ? o.props.value ?? null : null) : _(l, r);
            }
          })
        )
      )
    }
  );
};
se.Item = xe;
export {
  me as ACCORDION_FADE_DURATION_MS,
  se as Accordion,
  de as useToggle
};
